import { defineMessages } from 'react-intl';

export const freightBookingWizardContainerMessages = defineMessages({
  noProviderConnected: {
    id: '+AQSr4',
    description: 'Error shown when no freight provider is connected and the wizard tries to re-rate',
    defaultMessage: 'No freight provider connected. Please connect a provider in Settings.',
  },
  failedToRetrieveQuotes: {
    id: 'G9QjOz',
    description: 'Error shown when the freight quote request returns no usable quotes in the booking wizard',
    defaultMessage: 'Failed to retrieve quotes.',
  },
  rateFetchError: {
    id: 'snII3g',
    description: 'Generic error shown when an unexpected error occurs while fetching freight rates in the booking wizard',
    defaultMessage: 'An error occurred while fetching rates.',
  },
  saveQuoteSuccess: {
    id: 'pmL7rR',
    description: 'Content of the notification shown when a freight quote draft is saved successfully from the booking wizard',
    defaultMessage: 'Saved quote.',
  },
  saveQuoteFailed: {
    id: 'Ltrp+G',
    description: 'Fallback error shown when saving a freight quote draft fails without a server message',
    defaultMessage: 'Failed to save quote.',
  },
  bookFailed: {
    id: 'L8QgTH',
    description: 'Fallback error shown when booking a freight shipment fails without a server message',
    defaultMessage: 'Failed to book shipment.',
  },
  loadSavedQuoteFailed: {
    id: 'sexF9x',
    description: 'Fallback error shown when loading a previously saved freight quote into the booking wizard fails',
    defaultMessage: 'Failed to load saved quote.',
  },
  loadBookedShipmentFailed: {
    id: '747tN6',
    description: 'Fallback error shown when loading a booked freight shipment for the confirmation view fails',
    defaultMessage: 'Failed to load shipment.',
  },
  bookSuccessButNoFulfillmentPlan: {
    description: 'Error shown when booking succeeds but the response contains no fulfillment plan, preventing the UI from updating',
    defaultMessage: 'Freight shipment booked successfully but an error occurred fetching updated data. Please reload the page.',
    id: 'h+5VFR',
  },
  viewBookedShipmentDataMissing: {
    description: 'Error shown in view-booked mode when the freight shipment entity cannot be resolved from the fulfillment plan',
    defaultMessage: 'Freight shipment data missing. Please reload the page.',
    id: 'S54BnE',
  },
  addShipFromSuccess: {
    id: 'TFsJSS',
    description: 'Success notification shown after a new ship-from location is added from within the freight booking wizard',
    defaultMessage: 'Ship from location added.',
  },
  createCustomerSuccess: {
    id: 'N0AUrL',
    description: 'Success notification shown when a new customer is created from the freight booking wizard',
    defaultMessage: 'New customer created successfully.',
  },
  createCustomerFailed: {
    id: 'lwEeUP',
    description: 'Error notification shown when creating a new customer from the freight booking wizard fails',
    defaultMessage: 'Failed to create new customer record.',
  },
  deleteDraftFailed: {
    id: 'TxkTyO',
    description: 'Error notification shown when deleting a freight quote draft fails',
    defaultMessage: 'Failed to delete draft.',
  },
  editShipFromSuccess: {
    id: 'GZqfmU',
    description: 'Success notification shown after editing a ship-from location from within the freight booking wizard',
    defaultMessage: 'Ship from location updated.',
  },
  saveLtlDefaultsSuccess: {
    id: '9jH84f',
    description: 'Success notification shown when LTL defaults are saved from the booking wizard',
    defaultMessage: 'Freight defaults saved.',
  },
  saveLtlDefaultsFailed: {
    id: 'diLhKu',
    description: 'Error notification shown when saving LTL defaults from the booking wizard fails',
    defaultMessage: 'Failed to save freight defaults.',
  },
  confirmCloseHeader: {
    description: 'Header of the confirmation dialog shown when closing the freight booking wizard with unsaved details',
    defaultMessage: 'Unsaved Changes',
    id: 'WvAaeX',
  },
  confirmCloseBody: {
    description: 'Body of the confirmation dialog shown when closing the freight booking wizard with unsaved details',
    defaultMessage: "Your shipment details haven't been saved. Save them as a draft to finish later, or discard them and close.",
    id: 'qmGS8O',
  },
  confirmCloseSaveDraft: {
    description: 'Button that saves the in-progress freight shipment as a draft and closes the booking wizard',
    defaultMessage: 'Save Draft',
    id: '5Hc0ns',
  },
  confirmCloseDiscard: {
    description: 'Button that discards the in-progress freight shipment and closes the booking wizard',
    defaultMessage: 'Discard',
    id: 'fV/Bw0',
  },
  confirmCloseKeepEditing: {
    description: 'Button that dismisses the confirmation dialog and leaves the freight booking wizard open',
    defaultMessage: 'Keep Editing',
    id: 'ic/YmU',
  },
});
